import { render, staticRenderFns } from "./dataOverview.vue?vue&type=template&id=2b5090ef&scoped=true"
import script from "./dataOverview.vue?vue&type=script&lang=js"
export * from "./dataOverview.vue?vue&type=script&lang=js"
import style0 from "./dataOverview.vue?vue&type=style&index=0&id=2b5090ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5090ef",
  null
  
)

export default component.exports